import { atom } from 'jotai';

// Shared atom for user roles across the application
const rolesAtom = atom([]);

export default rolesAtom;
